import { observable, computed, reaction, extendObservable, action } from "mobx";
import { http, urlApi } from '../../../config/Constantes'
import LoginService from "../../../services/LoginService";
import UserService from "../../../services/UserService";
import OcupacaoPatioService from "../../../services/OcupacaoPatioService";
import lscache from "lscache";
import { setCookie } from "../../../utils/security";
import pesquisa_cx_json from '../pesquisa_cx_ssa.json';

export default class LoginStore {

    @observable token;
    @observable usuario;
    @observable emailRecuperar;
    @observable usuarioLogado;
    @observable senha;
    @observable nome;
    @observable mensagemErro;
    @observable mensagemErroRecuperar;
    @observable logging;
    @observable loadingUsuarioLogado;
    @observable isLogado;
    @observable tokenTime;
    @observable isAdmin;
    @observable alreadyRedirected;
    @observable redirectUrl;
    @observable notificacaoAberta;

    @observable showModalAlterarSenha;
    @observable atualizado

    @observable senhaAtual;
    @observable novaSenha;
    @observable confirmaSenha;
    @observable msgSenha;
    @observable senhaAlterada;
    @observable alterandoSenha;
    @observable mostrarRedefinirSenha; 
    @observable modalSenhaAlteradaSucesso;
    @observable desabilitaRedefinirSenha;
    @observable showModalPalavraChave;
    @observable mfaAtualizado


    @observable ddd;
    @observable celular;
    @observable msgSenha;
    @observable msgCelular;
    @observable senhakeyWord;
    @observable alterandokeyWord;

    @observable ocupacaoTecon;
    @observable ocupacaoDepot;
    @observable iconeAtivo;
    @observable menusUsuario;
    @observable permissoes;
    @observable statusAcessar;
    @observable acl;

    constructor() {
        this.usuario = "";
        this.iconeAtivo = false;
        this.ocupacaoTecon = "";
        this.ocupacaoDepot = "";
        this.emailRecuperar = "";
        this.senha = "";
        this.mensagemErro = lscache.get('errorMessage') || "";
        this.token = window.localStorage.getItem('jwt');
        this.nome = window.localStorage.getItem('loggedUserName');
        this.id = window.localStorage.getItem('loggedUserId');
        this.isAdmin = window.localStorage.getItem('isAdmin');

        this.loginService = new LoginService();
        this.userService = new UserService();
        this.ocupacaoPatioService =  new OcupacaoPatioService();

        this.usuarioLogado = {};
        this.logging = false;
        this.getUsuarioLogado();
        this.isLogado = false;
        this.alreadyRedirected = false;
        
        this.showModalPalavraChave = false;
        this.mfaAtualizado = true;
        this.showModalAlterarSenha = false;
        this.atualizado = true;
        this.alterandoSenha = false;
        this.alterandokeyWord = false;
        this.mostrarRedefinirSenha = false;
        this.desabilitaRedefinirSenha = false;
        reaction(
            () => this.nome,
            nome => {
                if (nome) {
                    window.localStorage.setItem('loggedUserName', nome);
                } else {
                    window.localStorage.removeItem('loggedUserName');
                }
            }
        );
        this.senhaAtual = "";
        this.novaSenha = "";
        this.confirmaSenha = "";
        this.msgSenha = "";
        this.msgCelular = "";
        this.modalSenhaAlteradaSucesso = false;
        this.mensagemErroRecuperar = "";
        this.senhaAlterada = false;
        this.menusUsuario = [];
        this.permissoes = window.localStorage.getItem('permissoes') || [];
        this.sideBarMontado = false;
        this.statusAcessar = 0; // Controle da aba Acessar: 0-Login; 1-Recuperar senha; 2-Msg de sucesso recuperar senha; 3
        this.acl = window.localStorage.getItem('acl') || [];
        this.notificacaoAberta = false;
    }

    setStatus = (status) => {
        this.statusAcessar = status;
        switch (status) {
            case 0:
                this.mensagemErroRecuperar = "";
                this.emailRecuperar = "";
                break;
            case 1:
                this.mensagemErro = "";
                break;
            case 2:
                this.emailRecuperar = "";
                this.mensagemErro = "";
                break;
            case 3:
                this.mensagemErroRecuperar = "";
                this.emailRecuperar = "";
                this.mensagemErro = "";
                this.senha = "";
                break;
            default:
                break;

        }
    }
    getUsuarioLogado() {
        this.loadingUsuarioLogado = false;
    }

    toggleNotificacao = () => {
        this.notificacaoAberta = !this.notificacaoAberta;
    }

    setToken(value) {
        this.token = value;
    }

    setUsuario(value) {
        this.usuario = value;
    }

    setEmailRecuperar(value) {
        this.emailRecuperar = value;
    }

    setSenha(value) {
        this.senha = value;
    }

    setPalavraChave(palavraChave){
        this.palavraChave = palavraChave;
    }

    setSenhaAtual(value) {
        this.senhaAtual = value;
    }

    setNovaSenha(value) {
        this.novaSenha = value;
    }

    setConfirmaSenha(value) {
        this.confirmaSenha = value;
    }

    setTokenTime(value) {
        this.tokenTime = value;
    }

    setMessagemErro() {
        this.mensagemErro = lscache.get('errorMessage') || ""
    }

    setDDD(value) {
        this.ddd = value;
    }

    setCelular(value) {
        this.celular = value;
    }

    abrirModalAlterarSenha = () => {
        this.senhaAlterada = false;
        this.senhaAtual = "";
        this.novaSenha = "";
        this.confirmaSenha = "";
        this.msgSenha = "";

        this.atualizado = false;
        this.showModalAlterarSenha = true;
    }

    fecharModalAlterarSenha() {
        this.showModalAlterarSenha = false;
    }

    abrirModalPalavraAtualizarCelular = () => {
        this.mfaAtualizado = false;
        this.showModalPalavraChave = true;
    }

    fecharModalPalavraChave() {
        this.showModalPalavraChave = false;
    }

    handleOtpPaste = (e) => {
        e.preventDefault();

        const pasteData = e.clipboardData.getData("text").trim();
        if (!pasteData) return;

        const digits = pasteData.replace(/\D/g, "").split("").slice(0, this.otp.length);

        digits.forEach((digit, idx) => {
            this.otp[idx] = digit;
            if (this.inputsRef[idx]) {
            this.inputsRef[idx].value = digit;
            }
        });

        if (this.setState) this.setState({ otp: this.otp });

        const nextEmpty = digits.length < this.otp.length ? digits.length : this.otp.length - 1;
        if (this.inputsRef[nextEmpty]) {
            this.inputsRef[nextEmpty].focus();
        }
    };

    login = async (e) => {
        e.preventDefault();
        this.mostrarRedefinirSenha = false;
        try {
            this.mensagemErro = '';
            this.logging = true;
            const  FirstAcess = lscache.get("FirstAcess");
            const  dddCache = lscache.get("Ddd");
            const  PhoneCache = lscache.get("Phone");
            lscache.flush();
            const response = await this.loginService.login({ "username": this.usuario, "password": this.senha, "grant_type": "password" });
            if (response.error !== undefined) {
                if(response.error.includes("Usuário com senha expirada")) {
                    this.mostrarRedefinirSenha = true;
                }
                this.logging = false;
                throw new Error(response.error);
            } else {
                if(process.env.ssa){
                    this.ativarPesquisaTrackco(response);   
                }
                lscache.remove("errorMessage");
                lscache.set('access_token', "Bearer " + response.access_token, response.expires_in);
                lscache.set('refresh_token',response.refresh_token);
                lscache.set('short_access_token',response.short_access_token);
                lscache.set('MembershipuserId', response.MembershipUserId);
                lscache.set('Nome', response.Name);
                lscache.set('Email', response.Email);
                lscache.set('Ddd', dddCache);
                lscache.set('Phone', PhoneCache);
                lscache.set('Perfil', response.Perfil ? JSON.parse(response.Perfil) : []);
                lscache.set('InternoExterno', response.InternoExterno);
                await this.getUsuarioMenus();
                await this.loadAcl()
                this.logging = false;
                this.isLogado = true;

                if(FirstAcess == 0){
                    this.abrirModalPalavraAtualizarCelular();
                }
            }
        }
        catch (error) {
            const { name, message } = error;
            this.isLogado = false;
            this.logging = false;
            this.mensagemErro = message.toString().replace("Error: ", "");
            lscache.set("errorMessage", this.mensagemErro);
            this.statusAcessar = 0;
        }
    }

    validaLogin = async (e) => {
        e.preventDefault();
        this.mostrarRedefinirSenha = false;

        try {
            this.mensagemErro = '';
            this.logging = true;
            lscache.flush();

            const formData = new URLSearchParams();
            formData.append('usuario', this.usuario);
            formData.append('senha', this.senha);

            const response = await fetch(`${urlApi}/mfa/validarLogin`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: formData.toString()
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(errorText || 'Erro ao autenticar o usuário.');
            }

            const result = await response.json();

            if (result.error) {
                if (result.error.includes("Usuário com senha expirada")) {
                    this.mostrarRedefinirSenha = true;
                }
                this.logging = false;
                throw new Error(result.error);
            }

            if(result.EnableMfa === false){
                await this.login(e);
                return;
            }

            // login foi validado e gravado pending login
            lscache.remove("errorMessage");
            lscache.set("PendingLogin", result, 5 * 60); 
            lscache.set("Email", result.Email);
            lscache.set("UserName", result.UserName);
            lscache.set("FirstAcess", result.FirstAcess);
            lscache.set("Ddd", result.Ddd);
            lscache.set("Phone", result.Phone);
            

            if (result.FirstAcess === 0) {
                await this.setStatus(8);
            }else if(result.StatusMFA === '0'){
                await this.setStatus(7);
                await this.handleSendEmail(); 
                this.startResendTimer();
            }else {
                await this.setStatus(4);
            }

            this.logging = false;
            this.isLogado = false;

        } catch (error) {
            const { message } = error;
            this.isLogado = false;
            this.logging = false;
            this.mensagemErro = message.toString().replace("Error: ", "");
            lscache.set("errorMessage", this.mensagemErro);
            this.statusAcessar = 0;
        }
    }

    getEmail() {
        const email = lscache.get('Email') || '';
        return this.maskEmail(email);
    }

    getPhone() {
        const phone = (lscache.get('Ddd') || '') + (lscache.get('Phone') || '');
        return this.maskPhone(phone);
    }

    maskEmail(email) {
        if (!email) return '';
        const [user, domain] = email.split('@');
        const visiblePart = user.slice(0, 4);
        return `${visiblePart}*****@${domain}`;
    }

    maskPhone(phone) {
        if (!phone) return '';
        const clean = phone.replace(/\D/g, '');
        const start = clean.slice(0, 3);
        const end = clean.slice(-3);
        return `${start}*****${end}`;
    }

    RecuperaOcupacaoPatio = () => {

        this.ocupacaoPatioService.recuperaIconeAtivo().then(response => {
            if (response.status === 200) {
                if (response.data === "S") 
            {
                this.iconeAtivo = true;
            }
            else {
                this.iconeAtivo = false;
            }
            } 
            this.logging = false;
        }).catch(error => {
            console.log(error);
        });



        this.ocupacaoPatioService.recuperaOcupacaoTecon().then(response => {
            if (response.status === 200) {
                this.ocupacaoTecon = response.data;
            } else {
                this.ocupacaoTecon = ""
            }
            this.logging = false;
        }).catch(error => {
            console.log(error);
        });

        this.ocupacaoPatioService.recuperaOcupacaoDepot().then(response => {
            if (response.status === 200) {
                this.ocupacaoDepot = response.data;
            } else {
                this.ocupacaoDepot = ""
            }
            this.logging = false;
        }).catch(error => {
            console.log(error);
        });



    }

    RecuperarSenha = (e) => {
        e.preventDefault();
        this.mensagemErroRecuperar = "";
        this.logging = true;
        if (this.emailRecuperar) {

            this.userService.RecuperarSenha(this.emailRecuperar).then(response => {
                if (response.status === 200) {
                    this.mensagemErroRecuperar = response.data.Message;
                    this.setStatus(2);
                } else {
                    this.mensagemErroRecuperar = response.data.Message;
                }
                this.logging = false;
            }).catch(error => {
                console.log(error);
            });
        }
        else {
            this.mensagemErroRecuperar = `Necessário informar e-mail`;
        }
    }

    getUsuarioMenus = async () => {
        try {
            const MembershipuserId = lscache.get('MembershipuserId');
            if (MembershipuserId) {
                let response = await this.userService.menusUsuario();
                if (response.data && Array.isArray(response.data)) {
                    this.menusUsuario = response.data;
                    if (this.menusUsuario && this.menusUsuario.length > 0) {
                        this.permissoes = this.menusUsuario.map(m => m.Codigo)
                        lscache.set('permissoes', this.permissoes)
                    }
                    return true;
                }
                else {
                    return false;
                }
            }
        }
        catch (error) {
            console.log(error)
        }

    }

    fecharModalAlterarSenhaSucesso = () => {
        this.modalSenhaAlteradaSucesso = false;
    }

    salvarSenhaUsuarioNaoLogado = (e) => {
        e.preventDefault();
        
        /**
         *  Preciso usar fetch pois os serviços que usam httpPost e httpGet dependem de um token de acesso.
        */

        if(this.senhaAtual === this.confirmaSenha) {
            fetch(`${urlApi}/Acesso/AlterarSenhaAnonyous?usuario=${this.usuario}&senhaAtual=${this.senhaAtual}&novaSenha=${this.novaSenha}`,{method: 'POST'}).then(res => {
                return res.json();
            }).then(res => {
                if(res.ExceptionMessage) {
                    this.msgSenha = res.ExceptionMessage;
                } else {
                    this.statusAcessar = 0;
                    this.mensagemErro = "Senha alterada com sucesso";
                }
            }).catch(err => console.error(err));
        }
        
    }

    salvarSenhaUsuario = () => {
        this.msgSenha = "";
        this.senhaAlterada = false;
        this.alterandoSenha = true;
        if(this.usuario === "") {
            this.msgSenha = "O campo usuário está vazio, por favor preencha o teu usuário na tela de login."
            this.alterandoSenha = false;
            return;
        }
        if (this.novaSenha === this.confirmaSenha) {
            this.userService.AlterarSenha(this.senhaAtual, this.novaSenha).then(response => {
                console.log(response);
                if (response.status === 200) {
                    this.msgSenha = response.data.Message;
                    this.senhaAlterada = true;
                } else {
                    if(response.data && response.data.Message) {
                        this.msgSenha = response.data.Message;
                    }else {
                        this.msgSenha = "Não foi possível realizar a troca da senha.";
                    }
                }
            }).catch(error => {
                console.log(error);
            }).finally(() => {this.alterandoSenha = false;});
        }
        else {
            this.msgSenha = `Os campos "Nova Senha" e "Confirmar" não coincidem`;
            this.alterandoSenha = false;
        }
    }

    salvarCelularUsuario = async () => {
        this.msgSenha = "";
        this.msgCelular = "";
        this.alterandokeyWord = true;

        if (this.usuario === "") {
            this.msgCelular = "O campo usuário está vazio, por favor preencha o teu usuário na tela de login."
            this.alterandokeyWord = false;
            return false;
        }

        try {
            const response = await this.userService.AlterarCelular(this.ddd, this.celular);

            if (response.status === 200) {
                this.msgCelular = response.data.Message;
                return true;
            }

            if (response.data && response.data.Message) {
                this.msgCelular = response.data.Message;
                return false;
            }

            this.msgCelular = "Não foi possível realizar a troca do número de celular.";
            return false;

        } catch (error) {
            this.msgCelular = "Erro ao comunicar com o servidor.";
            return false;
        }
    }

    salvarSenhaAnonimo = () => {
        this.msgSenha = "";
        this.alterandoSenha = true;
        this.desabilitaRedefinirSenha = true;
        if (this.novaSenha === this.confirmaSenha) {
            this.userService.AlterarSenhaAnonimo(this.usuario, this.senhaAtual, this.novaSenha).then(response => response.json())
            .then(response => {
                console.log(response);
                if (response.Message.includes("Senha alterada com sucesso.")) {
                    this.mensagemErroRecuperar = response.Message;
                    this.alterandoSenha = false;
                    this.mostrarRedefinirSenha = false;
                    this.desabilitaRedefinirSenha = false;
                    this.setStatus(2);
                } else {
                    if(response.data && response.data.Message) {
                        this.desabilitaRedefinirSenha = false;
                        this.msgSenha = response.data.Message;
                    }else {
                        this.desabilitaRedefinirSenha = false;
                        this.msgSenha = "Não foi possível realizar a troca da senha.";
                    }
                }
            })
            .catch(error => {
                console.log(error);
            }).finally(() => {this.alterandoSenha = false;this.desabilitaRedefinirSenha = false;});
        }
        else {
            this.msgSenha = `Os campos "Nova Senha" e "Confirmar" não coincidem`;
            this.alterandoSenha = false;
        }
    }

    reset = () => {
        this.usuario = "";
        this.senha = "";
        this.mensagemErro = "";
        this.token = "";
        this.nome = "";
        this.id = "";
        this.isAdmin = "";
        this.usuarioLogado = {};
        this.logging = false;
        this.isLogado = false;
        this.alreadyRedirected = false;
        this.showModalAlterarSenha = false;
        this.showModalPalavraChave = false;
        this.atualizado = true;
        this.mfaAtualizado = true;
        this.senhaAtual = "";
        this.novaSenha = "";
        this.confirmaSenha = "";
        this.msgSenha = "";
        this.mensagemErroRecuperar = "";
        this.senhaAlterada = false;
        this.menusUsuario = [];
        this.permissoes = [];
        this.acl = [];
        lscache.flush();
    }

    logout = () => {
        this.reset()
    }

    loadAcl = async () => {
        this.acl = []
        const { data } = await this.userService.listarAcl()
        if (data && Array.isArray(data) && data.length > 0) {
            this.acl = data
            lscache.set('acl', this.acl)
        }
    }

    @action
    can = (tarefa, operacao) => {
        if (this.acl === null || !Array.isArray(this.acl)) this.acl = lscache.get('acl') || []
        return this.acl.some(f => f.Tarefa === tarefa && f.Operacoes.some(s => s === operacao))
    }

    @observable otp = new Array(6).fill("");
    inputsRef = [];

    @action
    handleOtpChange = (value, index) => {
        if (isNaN(value)) return;

        this.otp[index] = value;

        if (value !== "" && index < 5) {
            if (this.inputsRef[index + 1]) {
                this.inputsRef[index + 1].focus();
            }
        }
    };


    @action
    handleOtpKeyDown = (event, index) => {
        if (event.key === "Backspace" && !this.otp[index] && index > 0) {
            if (this.inputsRef[index - 1]) {
                this.inputsRef[index - 1].focus();
            }
        }
    };

    @observable resendTimer = 30;
    @observable canResend = false;

    startResendTimer = () => {
        this.canResend = false;
        this.resendTimer = 30;

        const interval = setInterval(() => {
            if (this.resendTimer > 0) {
                this.resendTimer -= 1;
            } else {
                this.canResend = true;
                clearInterval(interval);
            }
        }, 1000);
    };

    handleConfirmar = async (event) => {
        event.preventDefault();

        const email = lscache.get("Email");
        const code = this.otp.join("");

        const response = await fetch(`${urlApi}/mfa/validate`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email, code })
        });

        const data = await response.json();

        if (response.ok && data.ok) {
            await this.login(event);
        } else {
            this.mensagemErroRecuperar = data.Message || "Falha na validação do código.";
        }
    };


    handleSendEmail = async () => {
        try {
            const response = await fetch(`${urlApi}/mfa/send-email`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email: lscache.get("Email") }),
            });

            const data = await response.json();

            if (data.ok) {
            //this.startResendTimer(); 
            //this.setStatus(7);       
            } else {
                this.mensagemErroRecuperar = data.Message || "Erro ao enviar código.";
            }
        } catch (err) {
            this.mensagemErroRecuperar = err.Message || "Erro na comunicação com o servidor.";
        }
    };

    handleSendSMS = async () => {
        try {
            const response = await fetch(`${urlApi}/mfa/send-sms`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email: lscache.get("Email") }),
            });

            const data = await response.json();

            if (data.ok) {
            //this.startResendTimer(); 
            //this.setStatus(7);       
            } else {
                this.mensagemErroRecuperar = data.Message || "Erro ao enviar código.";
            }
        } catch (err) {
            this.mensagemErroRecuperar = err.Message || "Erro na comunicação com o servidor.";
        }
    };

    ativarPesquisaTrackco = (e)=>{
        if(e.InternoExterno == 'E'){
            const registrosPesquisa = pesquisa_cx_json  
           const registroEncontrado = registrosPesquisa.find(ele=>ele.membershipuserid == e.MembershipUserId);
            if(registroEncontrado){
                window.trackco_name = e.Name;
                window.trackco_email = e.Email;
                window.trackco_identification = e.MembershipUserId;                
                window.trackco_tag_empresa = e.Empresa;
                // window.trackco_tag_executivo = 'padrao';
                 window.trackco_tag_segmento = registroEncontrado.segmento;
                // window.trackco_tag_unidade = 'padrao';
                window.trackco_tag_telefone = e.Telefone;
                window.trackco_ativarPesquisa = true;
            }
        }
    }

}


// WEBPACK FOOTER //
// ./src/modules/login/stores/LoginStore.js